export default "__VITE_ASSET__ac7457a1__"